module.exports = __webpack_public_path__ + "img/brief_picture_06.cc078352.png";